import React, { Component } from 'react';

import './statuses.css';

class FileNotFound extends Component {
  render() {
    return (
      <div className="FileNotFound">
        <div className="main">
          <div className="title">Oops</div>
          <div className="body">
            <p>We could not find the content you are looking for.</p>
            <p>If you continue to have issues please contact support.</p>
          </div>
        </div>
      </div>
    );
  }
}

export default FileNotFound;



// WEBPACK FOOTER //
// ./src/scenes/statusPages/fileNotFound.js